import { render, staticRenderFns } from "./OpenTime.vue?vue&type=template&id=5f2d8df0"
import script from "./OpenTime.vue?vue&type=script&lang=js"
export * from "./OpenTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports